import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EditQuestionInQuestionSetModalPage } from './edit-question-in-question-set-modal.page';
import { ColorPickerModule } from 'ngx-color-picker';

const routes: Routes = [
  {
    path: '',
    component: EditQuestionInQuestionSetModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ColorPickerModule
  ],
  declarations: [EditQuestionInQuestionSetModalPage]
})
export class EditQuestionInQuestionSetModalPageModule {}
